<template>
    <div>
        <h1>Authenticating using refresh token...</h1>
    </div>
    </template>
    
    <script>
    export default {
        created() {
            const refreshToken = this.$route.query.refreshToken;
            const redirectUri = `${window.location.protocol}//${window.location.host}/callback`
            const state = this.$route.query.state;
            this.$store
                .dispatch("getTokenFromRefreshToken", {
                    refreshToken: refreshToken,
                    redirectUri: redirectUri,
                    state,
                }).then(() => {
                    this.$router.push({ name: "Client List" });
                });
        },
    };
    </script>
    